import React, { useEffect, useMemo, useState } from 'react';
import { StepContainer, NavigationButtons, FormField, InfoBox, RadioGroup } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { useLocation } from 'react-router-dom';
import { selfServiceApi } from '../../services/selfServiceApi';
import { contentKeys } from '../../constants/contentKeys';

const ConsentSelectChildStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [errors, setErrors] = useState<{ name?: string; cpr?: string }>({});
  const [intro, setIntro] = useState<string>('Angiv hvilket barn samtykket vedrører.');
  const [title, setTitle] = useState<string>('Vælg barn');
  const [children, setChildren] = useState<Array<{ name: string; cpr: string }>>([]);
  const [selectedChild, setSelectedChild] = useState<string>('');
  const location = useLocation();
  const isTest = useMemo(() => (new URLSearchParams(location.search).get('test') || '').toLowerCase() === 'true', [location.search]);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas_samtykke.consent_select_child).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setIntro(c.body[0]);}
    });
  }, []);

  useEffect(() => {
    selfServiceApi.getChildren({ test: isTest }).then(list => {
      setChildren(list);
      if (list.length === 0) {
        // Ingen børn fundet – gå til manuel indtastning efter fortsæt
        updateSelfServiceData('consentManualChild', true);
      }
    });
  }, [isTest, updateSelfServiceData]);

  const onNext = () => { goNext(); };

  return (
    <StepContainer title={title}>
      <InfoBox type="info"><p>{intro}</p></InfoBox>
      <div style={{ marginBottom: '1rem' }}>
        <h3>Vælg blandt dine børn</h3>
        {children.length > 0 ? (
          <RadioGroup
            name="consentChildSelect"
            options={[
              ...children.map((c, idx) => ({ value: String(idx), label: `${c.name} (${c.cpr.slice(0,6)}-****)` })),
              { value: 'manual', label: 'Et andet barn (indtast selv)' }
            ]}
            value={selectedChild}
            onChange={(v) => {
              setSelectedChild(v);
              if (v !== 'manual') {
                const c = children[Number(v)];
                updateSelfServiceData('consentChildName', c.name);
                updateSelfServiceData('consentChildCpr', c.cpr);
                updateSelfServiceData('consentManualChild', false);
                updateSelfServiceData('consentChildSelectedIndex', Number(v));
                setErrors({});
              } else {
                updateSelfServiceData('consentManualChild', true);
                updateSelfServiceData('consentChildSelectedIndex', undefined as any);
                // Ryd tidligere valg
                updateSelfServiceData('consentChildName', '');
                updateSelfServiceData('consentChildCpr', '');
              }
            }}
            legend="Dine børn"
          />
        ) : (
          <InfoBox type="info"><p>Vi kunne ikke finde børn via CPR. Tryk Fortsæt for at indtaste barnets oplysninger på næste trin.</p></InfoBox>
        )}
      </div>
      {/* Manuel indtastning flyttes til separat step */}
      <NavigationButtons onBack={goBack} onNext={onNext} />
    </StepContainer>
  );
};

export default ConsentSelectChildStep;
